import Img1 from '../../assets/images/menu/1.png';
import Img2 from '../../assets/images/menu/2.png';
import Img3 from '../../assets/images/menu/3.png';
import Img4 from '../../assets/images/menu/4.png';
import Img5 from '../../assets/images/menu/5.svg';
import { INTL_APP_CODE, RU_APP_CODE } from '../../common/constants';
import { TType } from '../../common/types';
import getI18N from '../../lib/i18n';

export type TMenuEntry = {
    id: TType;
    title: string;
    imageUrl: string;
};
const i18n = getI18N();

const getMenuEnties = (appCode = RU_APP_CODE) => {
    let entries: TMenuEntry[] = [
        { id: 'badge', title: i18n('Бейдж'), imageUrl: Img1 },
        { id: 'button', title: i18n('Кнопка'), imageUrl: Img2 },
        { id: 'card', title: i18n('Виджет с картой'), imageUrl: Img3 },
        { id: 'link', title: i18n('Ссылка'), imageUrl: Img4 },
        { id: 'qr', title: i18n('QR код'), imageUrl: Img5 },
    ];
    if (appCode === INTL_APP_CODE) {
        entries = entries.filter((item) => item.id !== 'card');
    }

    return entries;
};

export default getMenuEnties;
